import { useCallback, useMemo, useState } from "react";

import { currentUserId, isAdmin } from "../../../../../../utils/constants";
import { useCard } from "../../../../../../reactQuery/cards";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import { getResponseData } from "../../../../../../reactQuery/response";

export function useDetailGridState({ cardId, cardData, boardPermission }) {
  const [activeTab, setActiveTab] = useState("all");
  const [textEditor, setTextEditer] = useState(false);
  const [aiEnabled, setAiEnabled] = useState(false);
  const isMobile = useResponsive("down", "md");
  const { card } = useCard(cardId);
  const currentCard = useMemo(() => getResponseData(card, {}), [card]);

  const addWorklogPermission = useMemo(
    () =>
      isAdmin() ||
      cardData?.board?.owner_user_id == currentUserId() ||
      boardPermission?.is_admin ||
      (cardData?.assigned_to_user_id == currentUserId() &&
        boardPermission?.can_add_work_log &&
        (Boolean(currentCard?.allocated_hours) ||
          boardPermission?.can_work_before_estimation)) ||
      cardData?.is_card_collaborator,
    [boardPermission, cardData, currentCard?.allocated_hours]
  );

  const canEditCard = useMemo(
    () =>
      isAdmin() ||
      cardData?.board?.owner_user_id === currentUserId() ||
      boardPermission?.is_admin ||
      (currentCard?.assigned_to_user_id == currentUserId() &&
        boardPermission?.can_edit_task) ||
      currentCard?.reporter === currentUserId(),
    [boardPermission, cardData?.board?.owner_user_id, currentCard]
  );

  const handleActiveTab = useCallback((activeItem) => {
    setActiveTab(activeItem);
  }, []);

  const handleTextEditor = useCallback(() => {
    if (
      isAdmin() ||
      cardData?.board?.owner_user_id == currentUserId() ||
      cardData?.reporter == currentUserId()
    ) {
      setTextEditer(true);
    }
  }, [cardData]);

  return {
    activeTab,
    addWorklogPermission,
    aiEnabled,
    canEditCard,
    currentCard,
    handleActiveTab,
    handleTextEditor,
    isMobile,
    setAiEnabled,
    setTextEditer,
    textEditor,
    toggleChatbotVisibility: () => setAiEnabled((previousValue) => !previousValue),
  };
}
